import { create } from "zustand";

interface TenantStore {
	tenant: any;
	tenantList: any[];
	setTenant: (tenant: any) => void;
	setTenantList: (tenantList: any[]) => void;
	getTenant: () => any;
	getTenantList: () => any[];
	isMasterTenant: boolean;
}

export const useTenantStore = create<TenantStore>((set, get) => ({
	tenant: null,
	tenantList: [],
	setTenant: (tenant) =>
		set((state) => {
			const mergedTenant = state.tenant
				? { ...state.tenant, ...tenant }
				: tenant;

			return {
				tenant: mergedTenant,
				isMasterTenant:
					mergedTenant?.role_key === import.meta.env.VITE_MASTER_TENANT_KEY,
			};
		}),
	setTenantList: (tenantList) => set({ tenantList }),
	getTenant: () => get().tenant,
	getTenantList: () => get().tenantList,
	isMasterTenant: false,
}));

// Export non-hook accessor for use in class methods
export const getTenantStore = () => useTenantStore.getState();

// Helper function to get tenant_id by operator (role_key)
export const getTenantIdByOperator = (operator: string, tenantList?: any[]) => {
	const list = tenantList ?? getTenantStore().getTenantList();
	const tenant = list.find((t) => t.role_key === operator);
	return tenant?.tenant_id;
};
